/* Moved out of snippets/pp-saved.liquid on 2026-10-03 so it is cached across pages (was inline on every page). Runs deferred; nothing calls it before the page has loaded. */
  (function () {
    if (!window.ppPreview || !window.ppPreview.has('save')) return;
    var KEY = 'ppSaved';
    var get = function () { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
    var put = function (l) { try { localStorage.setItem(KEY, JSON.stringify(l.slice(0, 40))); } catch (e) {} };
    var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    var toast = function (msg) {
      var t = document.querySelector('.pp-save-toast');
      if (!t) { t = document.createElement('div'); t.className = 'pp-save-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
      t.innerHTML = '<span></span><a href="/cart#pp-saved">View saved</a>'; t.firstChild.textContent = msg;
      t.classList.add('is-on'); clearTimeout(t.__t); t.__t = setTimeout(function () { t.classList.remove('is-on'); }, 4500);
    };
    var ready = function (fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); };

    // ---- Product page: one text link on the size-guide line ----
    ready(function () {
      var sg = document.querySelector('.pp-pdp__sizeguide'); if (!sg) return;
      var row = document.createElement('div'); row.className = 'pp-save-row';
      sg.parentNode.insertBefore(row, sg); row.appendChild(sg);
      sg.lastChild.nodeValue = ' See every size to scale';
      var b = document.createElement('button'); b.type = 'button'; b.className = 'pp-save-link';
      b.innerHTML = '<svg width="14" height="16" viewBox="0 0 14 18" fill="none" aria-hidden="true"><path d="M1.5 1.5h11v15L7 12.5l-5.5 4v-15z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg><span>Save for later</span>';
      row.appendChild(b);
      var url = location.pathname;
      var mark = function () { var on = get().some(function (x) { return x.url === url; }); b.classList.toggle('is-saved', on); b.lastChild.textContent = on ? 'Saved' : 'Save for later'; };
      mark();
      b.addEventListener('click', function () {
        var l = get().filter(function (x) { return x.url !== url; });
        if (b.classList.contains('is-saved')) { put(l); mark(); return; }
        var img = document.querySelector('meta[property="og:image"]');
        var h1 = document.querySelector('.pp-pdp__title');
        l.unshift({ url: url, title: (h1 ? h1.textContent : document.title).split(' by ')[0].trim(), img: img ? img.content : '', opts: 'Choose size and frame', t: Date.now() });
        put(l); mark(); toast('Saved for later. It’s under your basket.');
      });
    });

    // ---- Basket: "Save for later" per line + the saved list ----
    if (!/^\/cart\/?$/.test(location.pathname)) return;
    var cartJson = function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); };
    var addLinks = function () {
      document.querySelectorAll('.cart-item cart-remove-button').forEach(function (rb) {
        if (rb.__ppSave) return; rb.__ppSave = true;
        var b = document.createElement('button'); b.type = 'button'; b.className = 'pp-save-line'; b.textContent = 'Save for later';
        b.setAttribute('data-index', rb.getAttribute('data-index'));
        rb.parentNode.appendChild(b);
      });
    };
    // The real Shopify customer form (rendered by Liquid in <template id="pp-saved-form">), cloned in.
    var mountMail = function (box) {
      var tpl = document.getElementById('pp-saved-form'); if (!box || !tpl) return;
      box.innerHTML = '<p class="pp-saved__mail-h">Email me this list</p><p class="pp-saved__mail-p">Get your saved prints on any device, plus Book Club emails with new books and offers. Unsubscribe any time. See our <a href="/policies/privacy-policy">Privacy Policy</a>.</p>';
      var f = tpl.content.firstElementChild.cloneNode(true); box.appendChild(f);
      var inp = f.querySelector('input[type="email"]'), btn = f.querySelector('button[type="submit"]');
      Object.assign(inp.style, { flex: '1 1 auto', minWidth: '0', height: '48px', boxSizing: 'border-box', padding: '0 22px', background: '#fff', border: '1px solid rgba(52,56,63,.18)', borderRadius: '999px',
        fontFamily: 'var(--pp-font-body, Inter, sans-serif)', fontSize: '15px', color: '#34383F', outline: 'none', boxShadow: 'none', margin: '0' });
      Object.assign(btn.style, { flexShrink: '0', height: '48px', padding: '0 24px', border: '0', borderRadius: '999px', background: '#22C55E', color: '#fff',
        fontFamily: 'var(--pp-font-body, Inter, sans-serif)', fontSize: '15px', fontWeight: '700', cursor: 'pointer', boxShadow: '0 6px 16px rgba(34,197,94,.25)', margin: '0' });
    };
    var render = function () {
      var host = document.getElementById('pp-saved');
      if (!host) {
        host = document.createElement('section'); host.id = 'pp-saved'; host.className = 'pp-saved';
        var anchor = document.querySelector('.pp-cu') || document.querySelector('cart-items');
        if (!anchor) return;
        if (anchor.classList && anchor.classList.contains('pp-cu')) anchor.parentNode.insertBefore(host, anchor); else anchor.appendChild(host);
      }
      var l = get();
      if (!l.length) { host.hidden = true; return; }
      host.hidden = false;
      host.innerHTML = '<h2 class="pp-saved__h">Saved for later (' + l.length + ')</h2><p class="pp-saved__sub">Still thinking? They’ll wait here.</p><ul class="pp-saved__list">' +
        l.map(function (x, i) {
          return '<li class="pp-saved__i"><a href="' + esc(x.url) + '"><img src="' + esc(x.img) + '" alt="" loading="lazy"></a><div><a class="pp-saved__t" href="' + esc(x.url) + '">' + esc(x.title) + '</a>' +
            '<div class="pp-saved__o">' + esc(x.opts || '') + '</div><div class="pp-saved__b">' +
            (x.id ? '<button type="button" class="pp-saved__mv" data-pp-saved-mv="' + i + '">Move to basket</button>' : '<a class="pp-saved__mv" href="' + esc(x.url) + '">Choose size</a>') +
            '<button type="button" class="pp-saved__rm" data-pp-saved-rm="' + i + '">Remove</button></div></div></li>';
        }).join('') + '</ul>' +
        '<div class="pp-saved__mail" data-pp-saved-mailbox></div>';
      mountMail(host.querySelector('[data-pp-saved-mailbox]'));
    };
    ready(function () {
      addLinks(); render();
      var mo; new MutationObserver(function () { clearTimeout(mo); mo = setTimeout(addLinks, 80); }).observe(document.querySelector('cart-items') || document.body, { childList: true, subtree: true });
    });
    document.addEventListener('click', function (e) {
      var sv = e.target.closest && e.target.closest('.pp-save-line');
      if (sv) {
        e.preventDefault();
        var idx = +sv.getAttribute('data-index');
        cartJson().then(function (c) {
          var it = c.items[idx - 1]; if (!it) return;
          var p = it.properties || {};
          var opts = [p.Size, Object.keys(p).some(function (k) { return /Framed$/.test(String(p[k])); }) ? (p.FrameColor || 'Wood') + ' frame' : (p.Size ? 'No frame' : '')].filter(Boolean).join(' · ');
          var l = get(); l.unshift({ id: it.variant_id, props: p, url: it.url, title: (it.product_title || '').split(' by ')[0], img: it.image, opts: opts, t: Date.now() }); put(l);
          return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: idx, quantity: 0 }) });
        }).then(function () { location.reload(); });
        return;
      }
      var mv = e.target.closest && e.target.closest('[data-pp-saved-mv]');
      if (mv) {
        var l = get(), i = +mv.getAttribute('data-pp-saved-mv'), x = l[i]; if (!x) return;
        mv.textContent = 'Adding…';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: x.id, quantity: 1, properties: x.props || {} }] }) })
          .then(function (r) { if (!r.ok) throw r; l.splice(i, 1); put(l); location.reload(); })
          .catch(function () { location.href = x.url; });
        return;
      }
      var rm = e.target.closest && e.target.closest('[data-pp-saved-rm]');
      if (rm) { var l2 = get(); l2.splice(+rm.getAttribute('data-pp-saved-rm'), 1); put(l2); render(); }
    });
    document.addEventListener('submit', function (e) {
      var f = e.target; if (!f.matches || !f.matches('[data-pp-saved-mail]')) return;
      e.preventDefault();
      var note = f.querySelector('[name="contact[note]"]');
      if (note) note.value = 'Saved prints: ' + get().map(function (x) { return x.title + ' (' + location.origin + x.url + ')'; }).join('; ');
      f.querySelector('button[type="submit"]').disabled = true;
      var done = function () { var box = f.closest('[data-pp-saved-mailbox]'); if (box) box.innerHTML = '<p class="pp-saved__mail-ok">Thanks, you\u2019re signed up to the Blurby Book Club.</p>'; };
      fetch(f.action, { method: 'POST', body: new FormData(f), credentials: 'same-origin' }).then(done, done);
    });
  })();
